<template>
  <v-dialog v-model="dialogValue" max-width="500px" lazy>
    <v-card>
      <alert-banner :msg="alertMessage" />
      <v-form @submit.prevent="saveForm">
        <v-card-title>
          <span class="headline">
            Add Link
          </span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap row justify-center>
              <v-flex xs11>
                <v-text-field v-model="addForm.name" v-validate="'required'" name="name" label="Name*" required :error-messages="errors.collect('name')" />
              </v-flex>
              <v-flex xs11>
                <v-text-field v-model="linkUrl" v-validate="'required'" name="linkUrl" label="URL*" required :error-messages="errors.collect('linkUrl')" />
              </v-flex>
              <v-flex xs11>
                <v-autocomplete v-model="addForm.parentItemId" :items="directories" label="Location (Optional)" name="location" item-value="id" item-text="path" :error-messages="errors.collect('location')" />
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <span class="pl-4">
            <small>*indicates required field</small>
          </span>
          <v-spacer />
          <v-btn flat @click="dialogValue = false">
            Close
          </v-btn>
          <v-btn type="submit" color="secondary darken-1" flat :loading="saving">
            Add Link
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
  import axios from 'axios';

  export default {
    props: {
      dialog: {
        type: Boolean,
        default: false,
      },

      courseId: {
        type: Number,
        default: null,
      },
    },

    data: () => ({
      defaultAddForm: {
        name: '',
        categorized: true,
        parentItemId: '',
      },
      addForm: {
        name: '',
        categorized: true,
        parentItemId: '',
      },
      linkUrl: '',
      directories: [],
      saving: false,
    }),

    computed: {
      dialogValue: {
        get() {
          return this.dialog;
        },
        set(value) {
          this.$emit('update:dialog', value);
        },
      },
    },

    watch: {
      dialogValue(val) {
        if (!val) {
          setTimeout(() => {
              Object.keys(this.addForm).filter(key => key in this.defaultAddForm).forEach(key => this.addForm[key] = this.defaultAddForm[key]); // eslint-disable-line
            this.clearErrors();
          }, 300);
        } else {
          this.$validator.pause();
          this.getCategorizedDirectories();
        }
      },
    },

    methods: {
      async getCategorizedDirectories() {
        const { data } = await axios.get(`/api/courses/${this.courseId}/items/categorized/directories?depth=2`);
        this.directories = data;
      },

      async saveForm() {
        const result = await this.startFormProcessing();
        if (!result) return;
        this.saving = true;
        try {
          await axios.post(`/api/courses/${this.courseId}/links?linkUrl=${this.linkUrl}`, this.addForm);
          this.$emit('getCategorized');
          this.dialogValue = false;
        } catch (error) {
          this.processErrors(error, this.addForm);
        } finally {
          this.saving = false;
        }
      },
    },
  };
  </script>